import useTranslate from "../../../../modules/local/useTranslate";
import {notifyOnError} from "../../factory/createErrorEvent";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {
    group_create_Api,
    group_edit_Api,
    organization_deleteGroup_Api,
    organization_group_addMember_Api,
    organization_group_editMember_Api,
    organization_group_removeMember_Api,
    organization_group_setMemberActive_Api,
    organization_group_updateMemberInfo_Api
} from "../../../../apis";
import {NullAsDefault} from "../../../Shared";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";


export const useOrganizationGroupApi = ({
                                                 notifyListeners = {
                                                     onCreated: undefined,
                                                     onUpdated: undefined,
                                                     onDeleted: undefined,
                                                     onRefresh: undefined
                                                 },
                                             }) => {
    const t = useTranslate()

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
        onRefresh = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onCreate, ...creatingAsync} = useAsyncAction({
        onError,
        // Dùng chung endpoint /groups/create (GroupController@create) thay vì
        // /organizations/{id}/create-group riêng - endpoint này đã hỗ trợ sẵn group_type +
        // syncBusinessDetail() (vd tạo group_type=choir kèm GroupChoir), org-scope truyền qua
        // owner_type/owner_id trong payload thay vì path param.
        apiInfo: group_create_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
            onRefresh()
        },
    })

    const {handleAsyncAction: onUpdate, ...updatingAsync} = useAsyncAction({
        onError,
        apiInfo: group_edit_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
            onRefresh()
        },
    })

    const {handleAsyncAction: onDelete, ...deletingAsync} = useAsyncAction({
        onError,
        apiInfo: organization_deleteGroup_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
            onRefresh()
        },
    })

    const {handleAsyncAction: addMember, ...addingMemberAsync} = useAsyncAction({
        onError,
        apiInfo: organization_group_addMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: editMember, ...editingMemberAsync} = useAsyncAction({
        onError,
        apiInfo: organization_group_editMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: updateMemberInfo, ...updatingMemberInfoAsync} = useAsyncAction({
        onError,
        apiInfo: organization_group_updateMemberInfo_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: removeMember, ...removingMemberAsync} = useAsyncAction({
        onError,
        apiInfo: organization_group_removeMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: setMemberActive, ...settingMemberActiveAsync} = useAsyncAction({
        onError,
        apiInfo: organization_group_setMemberActive_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRefresh()
        },
    })


    return {
        onCreate, creatingAsync,
        onUpdate, updatingAsync,
        onDelete, deletingAsync,
        addMember, addingMemberAsync,
        editMember, editingMemberAsync,
        removeMember, removingMemberAsync,
        setMemberActive, settingMemberActiveAsync,
        updateMemberInfo, updatingMemberInfoAsync
    }
}